
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { RevPitchBlock } from '@ds/components/PitchBlock'

import { MODAL_NAMES } from '@config/constants'
import LoadInViewport from '@core/components/LoadInViewport'
import { createObserver } from '@core/helpers/vue-Intersection-observer'
import { trackEcoBlockImpression } from '@tracking/events'

import RenewedImpactModal from '../Modals/RenewedImpactModal'

import { ECO_BLOCK_ICONS } from './EcoBlock.constants'
import translations from './EcoBlock.translations'

export default {
  components: {
    RenewedImpactModal,
    RevLink,
    RevPitchBlock,
    LoadInViewport,
  },

  props: {
    trackingInfo: {
      type: Object,
      default: () => ({}),
    },
    ecoBlock: {
      type: Object,
      required: true,
    },
  },

  computed: {
    translations: () => translations,
    cards() {
      return this.ecoBlock.figures.map(({ title, description, type }) => ({
        title,
        description,
        image: {
          alt: '',
          height: 150,
          src: this.$static(
            `/img/product/eco-block/${ECO_BLOCK_ICONS[type]}.svg`,
          ),
          width: 150,
        },
      }))
    },
  },

  mounted() {
    this.unobserve = this.watchInViewport()
  },

  destroyed() {
    if (typeof this.unobserve === 'function') {
      this.unobserve()
    }
  },

  methods: {
    handleModalOpen() {
      openModal(MODAL_NAMES.PRODUCT.RENEWED_IMPACT)
    },

    watchInViewport() {
      return createObserver(this.$el, () => {
        trackEcoBlockImpression({
          pageType: 'product',
          ...this.trackingInfo,
        })
      })
    },
  },
}
